export const ESTIMATING_STATIC_RATES = {
    salesTaxRate: 7.5,
    overheadPercent: 3.25,
} as const;

export type EstimatingFormState = {
    wasteFactorPercent: number;
    targetMarginPercent: number;
    bidAmountOverride: number | null;
    billedAmount: number | null;
    shingleUpgradeNotes: string;
    shingleUpgradeAmount: number | null;
    projectNotes: string;
    paymentType: string;
    paymentTerms: string;
    opPercent: number;
    referralFee: number;
    permitCost: number;
    dumpsterFee: number;
    eagleviewCost: number;
    jobPhotosFee: number;
};

export const defaultEstimatingFormState: EstimatingFormState = {
    wasteFactorPercent: 10,
    targetMarginPercent: 25,
    bidAmountOverride: null,
    billedAmount: null,
    shingleUpgradeNotes: "",
    shingleUpgradeAmount: null,
    projectNotes: "",
    paymentType: "insurance",
    paymentTerms: "Insurance claim — O&P 20%; deductible per policy",
    opPercent: 20,
    referralFee: 0,
    permitCost: 150,
    dumpsterFee: 450,
    eagleviewCost: 75,
    jobPhotosFee: 100,
};

export const PAYMENT_TYPE_OPTIONS = [
    { value: "insurance", label: "Insurance Claim" },
    { value: "cash", label: "Cash / Check" },
    { value: "financing", label: "Financing" },
    { value: "credit", label: "Credit Card" },
    { value: "debit", label: "Debit Card" },
] as const;

export const PAYMENT_TERMS_OPTIONS = [
    {
        value: "Insurance claim — O&P 20%; deductible per policy",
        label: "Insurance claim — O&P 20%; deductible per policy",
    },
    {
        value: "50% at project start; balance due upon completion",
        label: "50% at project start; balance due upon completion",
    },
    {
        value: "Financing per lender agreement",
        label: "Financing per lender agreement",
    },
    {
        value: "Credit card — 3% processing fee included",
        label: "Credit card — 3% processing fee included",
    },
    {
        value: "Debit card at project completion",
        label: "Debit card at project completion",
    },
] as const;
